/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
  Tooltip,
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import colorsDark from '../../assets/colors/dark';
import LazyloadingSelect from '../../components/LazyloadingSelect/LazyloadingSelect';
import { StateTag } from '../../components/StateTag';
import * as SERVICE from '../../constants/service.types';
import {
  NAMESPACE,
  NOTIFIES,
  DECODED_ACCESS_TOKEN,
} from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import { openMessage, socketEmitEvent } from '../../redux/actions';
import './index.scss';
import { getReportAccountApi } from '../../api/reportApi';
import storageService from '../../services/storage.service';
import { GroupTree } from './GroupTree';
import { beeXLogger } from '../../helpers/logger';
import {
  resetRecoverySharePage,
  updateRecoveryCameraTabOfSharePage,
  updateRecoveryGroupCameraTabOfSharePage,
  updateRecoveryMemberTabOfSharePage,
  updateRecoverySharePage,
} from '../../redux/recovery/action';
import {
  getRecoveryCameraTabOfSharePage,
  getRecoveryGroupCameraTabOfSharePage,
  getRecoveryMemberTabOfSharePage,
  getRecoverySharePage,
} from '../../redux/recovery/reducer';
import moment from 'moment';

const { confirm } = Modal;
const { Search } = Input;
const { TabPane } = Tabs;

const OrganizationPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeysCameraTab, setSelectedRowKeysCameraTab] = useState([]);
  const [cameras, setCameras] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  console.log('🚀 ~ OrganizationPage ~ cameras:', cameras);
  const [camerasByUser, setCamerasByUser] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  const [cameraGroupsByUser, setCameraGroupsByUser] = useState({
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    loading: false,
  });
  const [cameraGroups, setCameraGroups] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  const [stepAdd, setStepAdd] = useState(0);
  const [, forceUpdate] = useState();
  const {
    searchContacts,
    dataUser,
    isAuth,
    cameras: pageCamera,
    listDeviceByUser,
    listDeviceGroupByUser,
    userShareDevice,
    sharePermissionUsers,
    unShareUser,
    deleteSharePermissionGroup,
    namespace,
    groupMembers,
    sharePermissionGroup,
    accountByNamespace,
    userId,
    updateSharePermissionGroup,
    deviceGroup,
    listDeviceGroupByPage,
    userGroupsByDeviceGroups,
  } = useSelector((state) => state);
  const [isShareLoading, setIsShareLoading] = useState(false);
  const [isAddUserLoading, setIsAddUserLoading] = useState(false);
  const [timeRequest, setTimeRequest] = useState(new Date().getTime());
  const [userShares, setUserShares] = useState();
  const [userShareGroupDevice, setUserShareGroupDevices] = useState();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [checkSelect, setCheckSelect] = useState(null);
  const [filterAccountId, setFilterAccountId] = useState(null);
  const [filterGroupId, setFilterGroupId] = useState(null);
  const [filterSerial, setFilterSerial] = useState(null);
  const [duration, setDuration] = useState(0);
  const [checkFilterShare, setCheckFilterShare] = useState(null);
  const [checkUpdate, setCheckUpdate] = useState(null);
  const [checkEdit, setCheckEdit] = useState(null);
  const [checkCam, setCheckCam] = useState(false);
  const [searchContactData, setSearchContactData] = useState(searchContacts);
  const [checkAccountId, setCheckAccountId] = useState(null);
  const [checkGroupId, setCheckGroupId] = useState(false);
  const [checkSerial, setCheckSerial] = useState(false);
  const [keyTable, setKeyTable] = useState(Math.random());
  const [dataSearchCamera, setDataSearchCamera] = useState();
  const [dataSearchGroupCamera, setDataSearchGroupCamera] = useState();
  const [dataSelect, setDataSelect] = useState(0);
  const [dataGroupDefault, setDataGroupDefault] = useState();
  const [dataPermission, setDataPermission] = useState([]);
  const [dataPermissionSubmit, setDataPermissionSubmit] = useState([]);
  const [currentCameragroup, setCurrentCameraGroup] = useState({
    value: 0,
    label: t('All camera'),
  });
  const [activeTab, setActiveTab] = useState(0);
  const [dataSelectByUser, setDataSelectByUser] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const [dataShareUserId, setDataShareUserId] = useState();
  const [timeRequestCameraGroup, setTimeRequestCameraGroup] = useState(
    new Date().getTime(),
  );
  const [dataGroupIdSelect, setDataGroupIdSelect] = useState();
  const [accountResult, setAccountResult] = useState([]);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const unShareUserRef = useRef([]);
  const [searchMemberInput, setSearchMemberInput] = useState('');
  const { activeTab: recoveryActiveTab } =
    useSelector(getRecoverySharePage) || {};
  const {
    selectedGroup: recoverySelectedGroup,
    searchCamera: recoveryDataSearchCamera,
    rowSelection: recoveryRowSelectionCameraTab,
    pagination: recoveryPaginationCameraTab,
  } = useSelector(getRecoveryCameraTabOfSharePage) || {};
  const { selectedGroup: recoverySelectedGroupCamera } =
    useSelector(getRecoveryGroupCameraTabOfSharePage) || {};
  const {
    searchMember: recoverySearchMember,
    selectedMember: recoverySelectedMember,
    pagination: recoveryPaginationMember,
  } = useSelector(getRecoveryMemberTabOfSharePage) || {};

  const [activeMemberTab, setActiveMemberTab] = useState('1');

  useEffect(() => {
    return () => {
      dispatch(resetRecoverySharePage());
    };
  }, []);

  useEffect(() => {
    if (recoveryActiveTab) {
      setActiveTab(recoveryActiveTab);
    }
  }, [recoveryActiveTab]);

  useEffect(() => {
    if (unShareUser) {
      unShareUserRef.current.push(unShareUser);
    }
  }, [unShareUser]);

  useEffect(() => {
    return () => {
      unShareUserRef.current = [];
    };
  }, []);

  useEffect(() => {
    setAccountResult(accountByNamespace);
  }, [accountByNamespace]);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const getUserShareData = useCallback(
    (serials) => {
      /**
       * @params serials @Array of serials
       */
      if (serials) {
        let dataBody = {
          serials: serials.join(';'),
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_USER_SHARE_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setCheckCam(true);
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const getListGroupAccountByDeviceGroup = useCallback(
    (groupIds) => {
      /**
       * @params serials @Array of serials
       */

      if (groupIds?.length > 0) {
        let dataBody = {
          deviceGroupId: groupIds[0],
          namespace,
          timeRequest: new Date().getTime(),
          page: 0,
          size: 100,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setCheckCam(true);
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  useEffect(() => {
    if (
      sharePermissionUsers &&
      sharePermissionUsers.requestId === timeRequest
    ) {
      setIsShareLoading(false);
      setStepAdd(0);
      setIsAddUserLoading(false);
      if (sharePermissionUsers.result === 1) {
        openMessage(NOTIFIES.SUCCESS, sharePermissionUsers.message);
        const serials = sharePermissionUsers?.data?.shares.map(
          (device) => device?.deviceSerial,
        );
        const deviceGroupIdTemp = sharePermissionUsers?.data?.shares?.find(
          (device) => device?.deviceGroupId >= 0,
        );
        form.resetFields();
        getListGroupAccountByDeviceGroup([dataGroupIdSelect]);
        // likely never happens, data.shares was always empty
        if (deviceGroupIdTemp) {
          getListGroupAccountByDeviceGroup([deviceGroupIdTemp?.deviceGroupId]);
        } else if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, sharePermissionUsers.message);
      }
    }
  }, [form, getUserShareData, sharePermissionUsers, dataGroupIdSelect]);

  useEffect(() => {
    if (
      sharePermissionGroup &&
      sharePermissionGroup.requestId === timeRequest
    ) {
      setIsShareLoading(false);
      setIsAddUserLoading(false);
      setStepAdd(0);
      if (sharePermissionGroup.result === 1) {
        openMessage(NOTIFIES.SUCCESS, sharePermissionGroup.message);
        let serials =
          (sharePermissionGroup.data &&
            sharePermissionGroup.data.shares &&
            sharePermissionGroup.data.shares[0] &&
            sharePermissionGroup.data.shares[0].deviceSerial) ||
          '';
        form.resetFields();
        if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, sharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, sharePermissionGroup]);

  useEffect(() => {
    if (
      updateSharePermissionGroup &&
      updateSharePermissionGroup.requestId === timeRequest
    ) {
      setIsShareLoading(false);
      setIsAddUserLoading(false);
      setStepAdd(0);
      setEditGroupPermissionData(null);
      if (updateSharePermissionGroup.result === 1) {
        openMessage(NOTIFIES.SUCCESS, updateSharePermissionGroup.message);
        const serials =
          (updateSharePermissionGroup.data &&
            updateSharePermissionGroup.data.serials) ||
          '';
        const deviceGroupIdTemp =
          (updateSharePermissionGroup.data &&
            updateSharePermissionGroup.data.deviceGroupId) ||
          '';
        form.resetFields();
        if (deviceGroupIdTemp) {
          getListGroupAccountByDeviceGroup([deviceGroupIdTemp]);
        } else if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, updateSharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, updateSharePermissionGroup]);

  useEffect(() => {
    if (unShareUser && unShareUser.requestId === timeRequest) {
      setIsShareLoading(false);
      setStepAdd(0);

      if (unShareUser.result === 1) {
        setIsDeleteLoading(null);
        openMessage(NOTIFIES.SUCCESS, unShareUser.message);

        const { serials, deviceGroupId } = unShareUser.data || {};

        form.resetFields();

        if (deviceGroupId && deviceGroupId !== -1) {
          getListGroupAccountByDeviceGroup([deviceGroupId]);
        } else if (serials) {
          const serialArray = serials.includes(';')
            ? serials.split(';')
            : [serials];
          getUserShareData(serialArray);
        }
      } else {
        openMessage(NOTIFIES.WARNING, unShareUser.message);
      }

      dispatch(ACTIONS.unSharePermissionUserReturn(null));
      setTimeRequest(null);
    }
  }, [
    form,
    getUserShareData,
    unShareUser,
    getListGroupAccountByDeviceGroup,
    dispatch,
    timeRequest,
  ]);

  useEffect(() => {
    if (
      deleteSharePermissionGroup &&
      deleteSharePermissionGroup.requestId === timeRequest
    ) {
      setIsShareLoading(false);
      setStepAdd(0);
      if (deleteSharePermissionGroup.result === 1) {
        setIsDeleteLoading(null);
        openMessage(NOTIFIES.SUCCESS, deleteSharePermissionGroup.message);
        let serials =
          (deleteSharePermissionGroup.data &&
            deleteSharePermissionGroup.data.serials) ||
          '';
        form.resetFields();
        if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, deleteSharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, deleteSharePermissionGroup]);

  useEffect(() => {
    setSearchContactData(searchContacts);
  }, [searchContacts]);

  useEffect(() => {
    if (userShareDevice) {
      setCheckUpdate(null);
      setCheckEdit(null);
      handleFiler();
    }
  }, [userShareDevice]);

  useEffect(() => {
    beeXLogger.debug(
      '🚀 ~ OrganizationPage ~ userGroupsByDeviceGroups:',
      userGroupsByDeviceGroups,
    );
    if (userGroupsByDeviceGroups?.deviceGroupId) {
      setCheckUpdate(null);
      setCheckEdit(null);
      handleFilerGroupDevice();
    }
  }, [userGroupsByDeviceGroups]);

  useEffect(() => {
    if (pageCamera && pageCamera.timeRequest === timeRequest) {
      setCameras((state) => {
        dispatch(
          updateRecoveryCameraTabOfSharePage({
            pagination: {
              ...state.pagination,
              total: pageCamera.totalSize,
            },
          }),
        );
        return {
          ...state,
          loading: false,
          data: pageCamera.data,
          pagination: {
            ...state.pagination,
            total: pageCamera.totalSize,
          },
        };
      });
    }
  }, [pageCamera]);

  useEffect(() => {
    if (listDeviceByUser && listDeviceByUser.timeRequest === timeRequest) {
      setCamerasByUser((state) => ({
        ...state,
        loading: false,
        data: listDeviceByUser.devices,
        pagination: {
          ...state.pagination,
          total: listDeviceByUser.total,
        },
      }));
    }
  }, [listDeviceByUser, timeRequest]);

  useEffect(() => {
    if (listDeviceGroupByUser) {
      const listCameraGroupByUser =
        listDeviceGroupByUser?.deviceGroups?.filter(
          (item) =>
            item?.groupType === 'camera' &&
            item?.deviceGroupId &&
            item?.namespace === namespace,
        ) || [];
      setCameraGroupsByUser((prev) => ({
        ...prev,
        data: listCameraGroupByUser,
        pagination: {
          ...prev.pagination,
          current: 1,
          pageSize: 10,
          total: listCameraGroupByUser?.length || 0,
        },
        loading: false,
      }));
    }
  }, [listDeviceGroupByUser]);

  useEffect(() => {
    if (!dataShareUserId) {
      setCameraGroupsByUser({
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        loading: false,
      });
      dispatch(ACTIONS.listDeviceGroupByUserReturn(null));
    }
  }, [dataShareUserId]);

  useEffect(() => {
    if (isAuth === 1 && namespace && activeTab === 2) {
      setCameraGroups((state) => ({ ...state, loading: true }));
      const dataTimeRequest = new Date().getTime();
      let data = {
        name: '',
        page: 0,
        size: 10,
        timeRequest: dataTimeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      setTimeRequestCameraGroup(dataTimeRequest);
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, timeRequest, activeTab]);

  useEffect(() => {
    if (
      listDeviceGroupByPage &&
      listDeviceGroupByPage.timeRequest === timeRequestCameraGroup
    ) {
      setCameraGroups((state) => ({
        ...state,
        loading: false,
        data: listDeviceGroupByPage?.deviceGroups,
        pagination: {
          ...state.pagination,
          total: listDeviceGroupByPage?.total ?? 0,
        },
      }));
    }
  }, [listDeviceGroupByPage, timeRequestCameraGroup]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      setCameras((state) => ({ ...state, loading: true }));
      let data = {
        deviceType: 'camera',
        page: 0,
        size: 10,
        timeRequest,
        namespace,
      };
      beeXLogger.debug(
        '🚀 ~ OrganizationPage ~ LIST_ALL_DEVICE_BY_PAGE3:',
        data,
      );
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    // get detail device group data
    if (deviceGroup?.requestId === timeRequest && deviceGroup?.deviceGroup) {
      const dataCameras = deviceGroup?.deviceGroup?.devices || [];
      setCameras((state) => {
        dispatch(
          updateRecoveryCameraTabOfSharePage({
            pagination: {
              ...state.pagination,
              current: 1,
              pageSize: dataCameras?.length ?? 0,
              total: dataCameras?.length ?? 0,
            },
          }),
        );
        return {
          ...state,
          loading: false,
          data: dataCameras,
          pagination: {
            ...state.pagination,
            current: 1,
            pageSize: dataCameras?.length ?? 0,
            total: dataCameras?.length ?? 0,
          },
        };
      });
      setDataGroupDefault(dataCameras);
    }
  }, [deviceGroup]);

  useEffect(() => {
    if (accountByNamespace && userId) {
      const isAdmin = accountByNamespace.some(
        (account) => account.accountId === userId && account.role === 'admin',
      );
      if (isAdmin) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }

    if (dataUser) {
      if (
        dataUser.role === 'admin' ||
        (dataUser.role === 'member' && dataUser.detailRole === 'operator')
      ) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }

    setIsAdmin(false); // Nếu không tìm thấy isAdmin là true, thì isAdmin sẽ là false
  }, [accountByNamespace, userId, dataUser]);

  const handleRemoveShareUser = useCallback(
    (groupId, accountId, serial, deviceGroupId) => {
      confirm({
        title:
          groupId === -1
            ? t('Are you sure to remove this member?')
            : t('Are you sure to remove this group member?'),
        icon: <ExclamationCircleOutlined />,

        onOk() {
          if (userShares?.serials || deviceGroupId) {
            if (userShares?.serials) {
              setIsDeleteLoading(userShares.serials);
            }
            let data = {
              serials: serial,
              groupId: groupId ?? -1,
              namespace,
              accountId: groupId > 0 ? -1 : (accountId ?? -1),
              deviceGroupId: deviceGroupId ?? -1,
            };
            const dataTimeRequest = new Date().getTime();
            setTimeRequest(dataTimeRequest);
            setIsShareLoading(true);
            let dataObj = {
              appServiceType: SERVICE.UN_SHARE_PERMISSION_USER,
              requestId: dataTimeRequest,
              body: JSON.stringify(data),
            };
            setCheckSelect(null);
            setFilterAccountId(null);
            setFilterGroupId(null);
            setFilterSerial(null);
            setCheckFilterShare(null);
            setDataPermissionSubmit([]);
            form.setFieldsValue({
              select: null,
              groupId: null,
              accountId: null,
            });
            return dispatch(socketEmitEvent(dataObj));
          }
        },
        onCancel() {},
      });
    },
    [dispatch, namespace, t, timeRequest, userShares],
  );

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      const { field, order } = sort;
      setCameras((state) => {
        dispatch(
          updateRecoveryCameraTabOfSharePage({
            pagination: {
              ...state.pagination,
              current: pagination.current,
              pageSize: pagination.pageSize,
            },
          }),
        );
        return {
          ...state,
          pagination: {
            ...state.pagination,
            current: pagination.current,
            pageSize: pagination.pageSize,
          },
          loading: true,
        };
      });

      let data = {
        deviceType: 'camera',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        namespace,
        field,
        order,
      };
      beeXLogger.debug(
        '🚀 ~ OrganizationPage ~ LIST_ALL_DEVICE_BY_PAGE1:',
        data,
      );
      if (dataSearchCamera) {
        data.name = dataSearchCamera;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataSearchCamera],
  );

  const handleTableChangeMember = useCallback(
    (pagination, _, sort) => {
      setCamerasByUser((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        shareUserId: dataShareUserId,
        deviceType: 'camera',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        namespace,
      };
      beeXLogger.debug('🚀 ~ handleTableChangeMember ~ data:', data);
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_BY_USER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataShareUserId],
  );

  const handleTableGroupCameraChangeOfMember = useCallback(
    (pagination, _, sort) => {
      setCameraGroupsByUser((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: false,
      }));
    },
    [dispatch, namespace, timeRequest, dataShareUserId],
  );

  const handleTableChangeGroupDevice = useCallback(
    (pagination, _, sort) => {
      const dataTimeRequest = new Date().getTime();
      setCameraGroups((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        name: '',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest: dataTimeRequest,
        namespace,
      };
      if (dataSearchGroupCamera) {
        data.name = dataSearchGroupCamera;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      setTimeRequestCameraGroup(dataTimeRequest);
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataSearchGroupCamera],
  );

  const onShareUser = useCallback(
    (values) => {
      const { accountId, groupId, deviceGroupId } = values;
      confirm({
        title: deviceGroupId
          ? t('Are you sure to share those device groups?')
          : t('Are you sure to share those devices?'),
        icon: <ExclamationCircleOutlined />,
        onOk() {
          let dataBody = {
            serials: filterSerial ?? userShares?.serials ?? '',
            accountId: checkSelect !== '1' ? Number(accountId ?? -1) : -1,
            groupId: checkSelect === '1' ? Number(groupId ?? -1) : -1,
            deviceGroupId: Number(deviceGroupId ?? -1),
            namespace,
            permission: dataPermissionSubmit.join('_'),
            durationSecond: duration === 0 ? -1 : duration * 86400,
          };
          const dataTimeRequest = new Date().getTime();
          setTimeRequest(dataTimeRequest);
          setIsShareLoading(true);
          let dataObj = {
            appServiceType: SERVICE.SHARE_PERMISSION_USER,
            requestId: dataTimeRequest,
            body: JSON.stringify(dataBody),
          };
          setCheckSelect(null);
          setFilterAccountId(null);
          setFilterGroupId(null);
          setFilterSerial(null);
          setCheckFilterShare(null);
          setDataPermissionSubmit([]);
          form.setFieldsValue({
            select: null,
            groupId: null,
            accountId: null,
          });
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() {},
      });
    },
    [
      checkSelect,
      dispatch,
      namespace,
      t,
      timeRequest,
      userShares,
      dataPermissionSubmit,
      duration,
    ],
  );

  const handleCancelShare = () => {
    setCheckUpdate(null);
    setCheckEdit(null);
    if (userShareGroupDevice?.deviceGroupId) {
      handleFilerGroupDevice();
    } else {
      handleFiler();
    }
  };

  const handleUpdateShare = (
    groupId,
    accountId,
    permission,
    serial,
    deviceGroupId,
  ) => {
    const dataBody = {
      serials: serial,
      accountId: Number(accountId ?? -1),
      namespace,
      groupId: Number(groupId ?? -1),
      deviceGroupId: Number(deviceGroupId ?? -1),
      permission: permission,
    };
    const dataTimeRequest = new Date().getTime();
    setTimeRequest(dataTimeRequest);
    setIsShareLoading(true);
    let dataObj = {
      appServiceType: SERVICE.UPDATE_SHARE_PERMISSION_USER,
      requestId: dataTimeRequest,
      body: JSON.stringify(dataBody),
    };

    return dispatch(socketEmitEvent(dataObj));
  };

  const handleFilerType = (type) => {
    if (userShareGroupDevice?.deviceGroupId) {
    } else {
      if (type === '1') {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter((item) => item.groupId !== -1)) ||
          [];
        setUserShares({
          serials: userShareDevice?.serials,
          users: [...data],
        });
      }
      if (type === '2') {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter((item) => item.groupId === -1)) ||
          [];
        setUserShares({
          serials: userShareDevice?.serials,
          users: [...data],
        });
      }
    }
  };

  const handleFilerGroup = (value) => {
    const data =
      (userShareDevice &&
        userShareDevice.users &&
        userShareDevice.users.length > 0 &&
        userShareDevice.users.filter(
          (item) => item.groupId === Number(value),
        )) ||
      [];
    const serials =
      (userShareDevice &&
        userShareDevice.serials &&
        userShareDevice.serials.split(';')) ||
      [];
    let count = 0;
    let dataSerial = '';
    serials &&
      serials.length > 0 &&
      serials.map((item) => {
        if (data.find((item1) => item === item1.serial)) {
          count += 1;
        } else {
          dataSerial = `${dataSerial}${item};`;
        }
      });
    if (count === serials.length) {
      setCheckFilterShare(false);
    } else if (count > 0) {
      setCheckFilterShare(true);
      setFilterSerial(dataSerial);
    } else {
      setCheckFilterShare(true);
    }
    setUserShares({
      serials: userShareDevice?.serials,
      users: [...data],
    });
  };

  const handleFilerGroupDeviceSelect = (value) => {
    const dataGroupsTemp =
      userShareGroupDevice?.groups?.filter(
        (item) => item.id === Number(value),
      ) || [];
    setCheckFilterShare(true);
    setUserShareGroupDevices({
      ...userShareGroupDevice,
      groups: [...dataGroupsTemp],
    });
  };

  const handleFilerMember = (value) => {
    const data =
      (userShareDevice &&
        userShareDevice.users &&
        userShareDevice.users.length > 0 &&
        userShareDevice.users.filter(
          (item) =>
            item.accountId === Number(value) &&
            !(item.child && item.child.length > 0),
        )) ||
      [];
    const serials =
      (userShareDevice &&
        userShareDevice.serials &&
        userShareDevice.serials.split(';')) ||
      [];
    let count = 0;
    let dataSerial = '';
    serials &&
      serials.length > 0 &&
      serials.map((item) => {
        if (data.find((item1) => item === item1.serial)) {
          count += 1;
        } else {
          dataSerial = `${dataSerial}${item};`;
        }
      });
    if (count === serials.length) {
      setCheckFilterShare(false);
    } else if (count > 0) {
      setCheckFilterShare(true);
      setFilterSerial(dataSerial);
    } else {
      setCheckFilterShare(true);
    }
    setUserShares({
      serials: userShareDevice?.serials,
      users: [...data],
    });
  };

  const handleFiler = () => {
    if (checkSelect) {
      if (filterGroupId && !filterAccountId) {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter(
              (item) => item.groupId === Number(filterGroupId),
            )) ||
          [];
        setUserShares({
          serials: userShareDevice?.serials,
          users: [...data],
        });
      } else if (!filterGroupId && filterAccountId) {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter(
              (item) =>
                item.accountId === Number(filterAccountId) &&
                !(item.child && item.child.length > 0),
            )) ||
          [];
        setUserShares({
          serials: userShareDevice?.serials,
          users: [...data],
        });
      } else {
        if (checkSelect === '1') {
          const data =
            (userShareDevice &&
              userShareDevice.users &&
              userShareDevice.users.length > 0 &&
              userShareDevice.users.filter((item) => item.groupId !== -1)) ||
            [];
          setUserShares({
            serials: userShareDevice?.serials,
            users: [...data],
          });
        }
        if (checkSelect === '2') {
          const data =
            (userShareDevice &&
              userShareDevice.users &&
              userShareDevice.users.length > 0 &&
              userShareDevice.users.filter((item) => item.groupId === -1)) ||
            [];
          setUserShares({
            serials: userShareDevice?.serials,
            users: [...data],
          });
        }
      }
    } else {
      setUserShares({ ...userShareDevice });
    }
  };

  const handleFilerGroupDevice = () => {
    setUserShareGroupDevices({ ...userGroupsByDeviceGroups });
  };

  const handleSearchAccount = (e, isRecovering = false) => {
    if (!isRecovering) {
      dispatch(
        updateRecoveryMemberTabOfSharePage({
          searchMember: e.target.value || '',
        }),
      );
    }
    setSearchMemberInput(e.target.value || '');
    if (e.target.value) {
      const lowercaseValue = e.target.value.toLowerCase();
      const data = accountByNamespace?.filter((item) => {
        return (
          item?.fullName?.toLowerCase()?.includes(lowercaseValue) ||
          item?.phonenumber?.toLowerCase()?.includes(lowercaseValue) ||
          item?.email?.toLowerCase()?.includes(lowercaseValue)
        );
      });
      setAccountResult(data);
    } else {
      setAccountResult(accountByNamespace);
    }
  };

  useEffect(() => {
    if (
      recoverySearchMember?.toLowerCase()?.trim() !==
        searchMemberInput?.toLowerCase()?.trim() &&
      accountByNamespace?.length > 0
    ) {
      handleSearchAccount({ target: { value: recoverySearchMember } }, true);
    }
  }, [recoverySearchMember, searchMemberInput, accountByNamespace]);

  const expandedRowRender = (data) => {
    const columns1 = [
      {
        title: t('Camera'),
        dataIndex: 'serial',
        key: 'serial-share-device',
        width: '23%',
        render: (cell) => {
          const data =
            cameras &&
            cameras.data &&
            cameras.data.length > 0 &&
            cameras.data.find((item) => item.serial === cell);
          return (data && data.name) || '';
        },
      },
      {
        title: t('Full name'),
        dataIndex: 'fullName',
        key: 'fullName-share-device',
        width: '10%',
      },
      {
        title: t('Phone'),
        dataIndex: 'phoneNumber',
        key: 'phoneNumber-share-device',
        width: '13%',
      },
      {
        title: t('Permission'),
        key: 'permission-share-device',
        dataIndex: 'permission',
        width: '32%',
        render: (cell, row, index) => {
          const dataArr = (cell && cell.split('_')) || [];
          let check1 = false;
          let check2 = false;
          let check3 = false;
          let check4 = false;
          let check5 = false;
          if (dataArr.find((item) => item === 'live')) {
            check1 = true;
          }
          if (dataArr.find((item) => item === 'playback')) {
            check2 = true;
          }
          if (dataArr.find((item) => item === 'download')) {
            check3 = true;
          }
          if (dataArr.find((item) => item === 'upload')) {
            check4 = true;
          }
          if (dataArr.find((item) => item === 'share')) {
            check5 = true;
          }
          const onChange = (e, key) => {
            if (key === 'live') {
              let data = { ...userShares };
              let data1 = [];
              if (!check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'playback') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (!check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'download') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (!check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'upload') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (!check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'share') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (!check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            }
          };
          return (
            <React.Fragment>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'live')
                  )
                }
                onChange={(e) => onChange(e, 'live')}
                checked={check1}
              >
                {t('Live')}
              </Checkbox>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'playback')
                  )
                }
                onChange={(e) => onChange(e, 'playback')}
                checked={check2}
              >
                {t('Playback')}
              </Checkbox>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'download')
                  )
                }
                onChange={(e) => onChange(e, 'download')}
                checked={check3}
              >
                {t('Download')}
              </Checkbox>
              <Checkbox
                style={{ marginLeft: '0px' }}
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'upload')
                  )
                }
                onChange={(e) => onChange(e, 'upload')}
                checked={check4}
              >
                {t('Upload')}
              </Checkbox>
              <Checkbox
                style={{ marginLeft: '0px' }}
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'share')
                  )
                }
                onChange={(e) => onChange(e, 'share')}
                checked={check5}
              >
                {t('Share')}
              </Checkbox>
            </React.Fragment>
          );
        },
      },
      {
        title: t('Action'),
        key: 'action-share-device',
        width: '22%',
        render: (user, row, index) => {
          return (
            <div className="remove-users-button">
              {checkEdit === index &&
              checkAccountId === row.accountId &&
              checkGroupId === row.groupId &&
              checkSerial === row.serial ? (
                <>
                  <Button
                    loading={
                      isDeleteLoading === (userShares && userShares.serials)
                    }
                    style={{ marginRight: '10px' }}
                    size="small"
                    type="primary"
                    onClick={() =>
                      handleUpdateShare(
                        row.groupId,
                        row.accountId,
                        row.permission,
                        row.serial,
                      )
                    }
                  >
                    {t('Update')}
                  </Button>
                  <Button
                    loading={
                      isDeleteLoading === (userShares && userShares.serials)
                    }
                    size="small"
                    onClick={() => handleCancelShare()}
                  >
                    {t('Cancel')}
                  </Button>
                </>
              ) : (
                <div className="manager-member-actions">
                  <div
                    className="edit-button"
                    onClick={() => {
                      setCheckEdit(index);
                      setCheckUpdate(index);
                      setCheckAccountId(row.accountId);
                      setCheckGroupId(row.groupId);
                      setCheckSerial(row.serial);
                      handleFiler();
                    }}
                  >
                    <EditOutlined /> {t('Edit')}
                  </div>
                </div>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <Table
        scroll={{ y: '100%' }}
        columns={columns1}
        dataSource={data && data.child ? data.child : [data]}
        pagination={false}
      />
    );
  };

  const onChangeSelect = useCallback(
    (option, isRecovering = false) => {
      setCurrentCameraGroup(option);
      setDataSelect(option.value);
      if (!isRecovering) {
        dispatch(updateRecoveryCameraTabOfSharePage({ selectedGroup: option }));
      }
      if (option.value === 0) {
        setCameras((state) => {
          dispatch(
            updateRecoveryCameraTabOfSharePage({
              pagination: {
                size: 'small',
                current: 1,
                total: pageCamera.totalSize,
              },
            }),
          );
          return {
            ...state,
            loading: false,
            data: pageCamera.data,
            pagination: {
              size: 'small',
              current: 1,
              total: pageCamera.totalSize,
            },
          };
        });
      } else {
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        dispatch(
          socketEmitEvent({
            appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
            requestId: dataTimeRequest,
            body: JSON.stringify({
              namespace,
              deviceGroupId: option?.id,
              timeRequest,
            }),
          }),
        );
      }
      onResetUserShare();
      setKeyTable(Math.random());
    },
    [pageCamera, dispatch, namespace, timeRequest],
  );

  useEffect(() => {
    if (recoverySelectedGroup) {
      setCurrentCameraGroup(recoverySelectedGroup);
      onChangeSelect(recoverySelectedGroup, true);
    }
  }, [recoverySelectedGroup]);

  const onResetUserShare = () => {
    setCheckCam(false);
    form.resetFields();
    setIsAddUserLoading(false);
    setStepAdd(0);
    setCheckSelect(null);
    setSelectedRowKeysCameraTab([]);
    setFilterAccountId(null);
    setFilterGroupId(null);
    setFilterSerial(null);
    setCheckFilterShare(null);
    setUserShares(null);
    setUserShareGroupDevices(null);
    setDataPermissionSubmit([]);
    setDataSearchCamera(null);
    setDataSearchGroupCamera(null);
    setTimeRequestCameraGroup(new Date().getTime());
    setDataGroupIdSelect(dataGroupIdSelect);
    form.setFieldsValue({
      select: null,
    });
  };

  const removeAccents = (str) => {
    return str
      ? str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
          .replace(/Đ/g, 'D')
      : '';
  };

  const onSearchCamera = useCallback(
    (name) => {
      setDataSearchCamera(name?.trim());

      if (dataSelect === 0) {
        setCameras((state) => {
          dispatch(
            updateRecoveryCameraTabOfSharePage({
              pagination: {
                ...state.pagination,
                current: 1,
                pageSize: 10,
              },
            }),
          );
          return {
            ...state,
            pagination: {
              ...state.pagination,
              current: 1,
              pageSize: 10,
            },
            loading: true,
          };
        });
        const requestTime = timeRequest || new Date().getTime();
        setTimeRequest(requestTime);
        let data = {
          deviceType: 'camera',
          page: 0,
          size: 10,
          timeRequest: requestTime,
          namespace,
        };
        if (name?.trim()) {
          data.name = name?.trim();
        }
        beeXLogger.debug(
          '🚀 ~ OrganizationPage ~ LIST_ALL_DEVICE_BY_PAGE2:',
          data,
        );
        let dataObj = {
          appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      } else {
        if (name?.trim()) {
          const dataName = removeAccents(name?.trim()?.toLowerCase());
          const dataSearch =
            dataGroupDefault?.filter((item) =>
              removeAccents(item.name?.toLowerCase())?.includes(dataName),
            ) ?? [];
          setCameras((state) => {
            dispatch(
              updateRecoveryCameraTabOfSharePage({
                pagination: {
                  ...state.pagination,
                  current: 1,
                  pageSize: dataSearch?.length ?? 0,
                },
              }),
            );
            return {
              ...state,
              loading: false,
              data: dataSearch,
              pagination: {
                ...state.pagination,
                current: 1,
                pageSize: dataSearch?.length ?? 0,
                total: dataSearch?.length ?? 0,
              },
            };
          });
        } else {
          setCameras((state) => {
            dispatch(
              updateRecoveryCameraTabOfSharePage({
                pagination: {
                  ...state.pagination,
                  current: 1,
                  pageSize: dataGroupDefault?.length ?? 0,
                },
              }),
            );
            return {
              ...state,
              loading: false,
              data: dataGroupDefault,
              pagination: {
                ...state.pagination,
                current: 1,
                pageSize: dataGroupDefault?.length ?? 0,
                total: dataGroupDefault?.length ?? 0,
              },
            };
          });
        }
      }
    },
    [dataSelect, dataGroupDefault, dispatch, namespace, timeRequest],
  );

  useEffect(() => {
    if (recoveryDataSearchCamera !== dataSearchCamera) {
      setTimeout(() => {
        setDataSearchCamera(recoveryDataSearchCamera);
        onSearchCamera(recoveryDataSearchCamera);
      }, 200);
    }
  }, [recoveryDataSearchCamera, dataSearchCamera]);

  const onSearchGroupCamera = (name) => {
    setDataSearchGroupCamera(name?.trim());
    const dataTimeRequest = new Date().getTime();
    setCameraGroups((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: 1,
        pageSize: 10,
      },
      loading: true,
    }));
    let data = {
      name: '',
      page: 0,
      size: 10,
      timeRequest: dataTimeRequest,
      namespace,
    };
    if (name?.trim()) {
      data.name = name?.trim();
    }
    let dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
      requestId: dataTimeRequest,
      body: JSON.stringify(data),
    };
    setTimeRequestCameraGroup(dataTimeRequest);
    dispatch(socketEmitEvent(dataObj));
  };

  const handlePermissionCamera = (args) => {
    beeXLogger.debug('keys: ', args);
    let dataTemp = [];
    if (!args?.find((item) => !item?.permission?.includes('live'))) {
      dataTemp.push('live');
    }
    if (!args?.find((item) => !item?.permission?.includes('playback'))) {
      dataTemp.push('playback');
    }
    if (!args?.find((item) => !item?.permission?.includes('download'))) {
      dataTemp.push('download');
    }
    if (!args?.find((item) => !item?.permission?.includes('upload'))) {
      dataTemp.push('upload');
    }
    if (!args?.find((item) => !item?.permission?.includes('share'))) {
      dataTemp.push('share');
    }
    setDataPermission(dataTemp);
  };

  const handleListDeviceByUser = useCallback(
    (value) => {
      if (value) {
        setCamerasByUser((state) => ({ ...state, loading: true }));
        let dataBody = {
          shareUserId: value,
          deviceType: 'camera',
          namespace,
          page: 0,
          size: 10,
          timeRequest,
        };
        beeXLogger.debug('🚀 ~ LIST_DEVICE_BY_USER ~ dataBody:', dataBody);

        let dataObj = {
          appServiceType: SERVICE.LIST_DEVICE_BY_USER,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setDataShareUserId(value);
        onResetUserShare();
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [timeRequest, namespace, dispatch],
  );

  const handleListDeviceGroupByUser = useCallback((value) => {
    if (value) {
      setCameraGroupsByUser((state) => ({ ...state, loading: true }));
      let dataBody = {
        shareUserId: value,
        namespace,
      };
      beeXLogger.debug('🚀 ~ LIST_DEVICE_GROUP_BY_USER ~ dataBody:', dataBody);

      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_USER,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      setDataShareUserId(value);
      onResetUserShare();
      return dispatch(socketEmitEvent(dataObj));
    }
  }, []);

  const onChangeMemberTab = useCallback(
    (key) => {
      setActiveMemberTab(key);
      setSelectedRowKeysCameraTab([]);
      if (key === '1') {
        handleListDeviceByUser(dataShareUserId);
      } else if (key === '2') {
        handleListDeviceGroupByUser(dataShareUserId);
      }
    },
    [dataShareUserId, handleListDeviceByUser, handleListDeviceGroupByUser],
  );

  const onRemovePermission = useCallback(
    (record) => {
      beeXLogger.debug('record: ', record);

      const isGroupRecord = !!record?.deviceGroupId && !record?.serial;

      if (!isGroupRecord && record?.deviceGroup) {
        confirm({
          title: 'Unable to remove permission',
          content: 'You can not remove permission of camera in group',
          cancelButtonProps: {
            style: {
              display: 'none',
            },
          },
          okText: t('OK'),
          icon: <ExclamationCircleOutlined />,
        });

        return;
      }

      confirm({
        title: t('_REMOVE_PERMISSION', { name: record?.name }),
        icon: <ExclamationCircleOutlined />,
        okText: t('Remove'),
        onOk() {
          const data = isGroupRecord
            ? {
                serials: '',
                groupId: -1,
                namespace,
                accountId: dataShareUserId,
                deviceGroupId: record?.deviceGroupId ?? -1,
              }
            : {
                serials: record?.serial,
                groupId: record?.group?.groupId ?? -1,
                namespace,
                accountId: dataShareUserId,
                deviceGroupId: record?.deviceGroup?.deviceGroupId ?? -1,
              };
          beeXLogger.debug('UN_SHARE_PERMISSION_USER - body: ', data);
          const dataObj = {
            appServiceType: SERVICE.UN_SHARE_PERMISSION_USER,
            requestId: timeRequest,
            body: JSON.stringify(data),
          };
          beeXLogger.debug('dataObj', data);
          if (isGroupRecord) {
            setCameraGroupsByUser((state) => ({ ...state, loading: true }));
            setTimeout(() => {
              handleListDeviceGroupByUser(dataShareUserId);
            }, 300);
          } else {
            setCamerasByUser((state) => ({ ...state, loading: true }));
            setTimeout(() => {
              handleListDeviceByUser(dataShareUserId);
            }, 300);
          }
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() {},
      });
    },
    [
      dispatch,
      t,
      namespace,
      dataShareUserId,
      timeRequest,
      handleListDeviceByUser,
      handleListDeviceGroupByUser,
    ],
  );

  const handleExportAccountReports = useCallback(async () => {
    try {
      setIsLoadingExport(true);
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
      };
      const dataRes = await getReportAccountApi(
        token,
        { namespace },
        dataQuery,
      );
      beeXLogger.debug('dataRes: ', dataRes);
      setTimeout(() => {
        if (dataRes?.data) {
          const buttonElement = document.createElement('a');
          buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
            dataRes.data,
          )}`;
          buttonElement.target = '_blank';
          buttonElement.download = `report-account.csv`;
          buttonElement.click();
        } else {
          ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        }
        setIsLoadingExport(false);
      }, 800);
    } catch (error) {
      setTimeout(() => {
        setIsLoadingExport(false);
        ACTIONS.openMessage(
          NOTIFIES.WARNING,
          error?.response?.data?.message ?? 'Internal server error',
        );
      }, 800);
    }
  }, []);

  const [editGroupPermissionData, setEditGroupPermissionData] = useState(null);

  const activeEditGroupPermission = ({
    serial,
    deviceGroupId = -1,
    groupId,
    permission,
  }) => {
    const permissionData = permission.split('_').reduce((acc, item) => {
      if (item) {
        acc[item] = true;
      }
      return acc;
    }, {});

    setEditGroupPermissionData({
      serial,
      deviceGroupId,
      groupId,
      permissionData,
    });
  };

  const updateGroupPermission = (permission, value) => {
    if (!activeEditGroupPermission) return;

    setEditGroupPermissionData((state) => ({
      ...state,
      permissionData: {
        ...state.permissionData,
        [permission]: value,
      },
    }));
  };

  const commitEditGroupPermission = () => {
    beeXLogger.debug('commitEditGroupPermission: ', editGroupPermissionData);
    if (!editGroupPermissionData) return;

    const body = {
      serials: editGroupPermissionData.serial,
      groupId: editGroupPermissionData.groupId,
      deviceGroupId: editGroupPermissionData.deviceGroupId,
      permission: Object.keys(editGroupPermissionData.permissionData)
        .filter((key) => editGroupPermissionData.permissionData[key])
        .join('_'),
      namespace,
      accountId: -1,
    };

    const dataObj = {
      appServiceType: SERVICE.UPDATE_SHARE_PERMISSION_USER,
      requestId: timeRequest,
      body: JSON.stringify(body),
    };

    beeXLogger.debug('dataObj: ', dataObj);

    dispatch(socketEmitEvent(dataObj));
  };

  const onRowSelectionCameraTab = (keys, row, isRecovering = false) => {
    setSelectedRowKeysCameraTab(keys);
    if (!isRecovering) {
      dispatch(
        updateRecoveryCameraTabOfSharePage({
          rowSelection: {
            row,
            keys,
          },
        }),
      );
    }
    if (keys.length > 0) {
      handlePermissionCamera(row);
      return getUserShareData(keys);
    } else {
      return onResetUserShare();
    }
  };

  useEffect(() => {
    if (recoveryRowSelectionCameraTab) {
      onRowSelectionCameraTab(
        recoveryRowSelectionCameraTab.keys,
        recoveryRowSelectionCameraTab.row,
        true,
      );
    }
  }, [recoveryRowSelectionCameraTab]);

  useEffect(() => {
    if (recoveryPaginationCameraTab) {
      setCameras((prev) => ({
        ...prev,
        pagination: { ...recoveryPaginationCameraTab },
      }));
    }
  }, [recoveryPaginationCameraTab]);

  const onSelectGroupCamera = (keys, row, isRecovering = false) => {
    beeXLogger.debug('GroupTree - select', keys, row);
    if (!isRecovering) {
      dispatch(
        updateRecoveryGroupCameraTabOfSharePage({
          selectedGroup: {
            keys: keys,
            row: row,
          },
        }),
      );
    }
    if (keys.length > 0) {
      handlePermissionCamera(row);
      setDataGroupIdSelect(keys[0]);
      return getListGroupAccountByDeviceGroup(keys);
    } else {
      setDataGroupIdSelect(null);
      return onResetUserShare();
    }
  };

  useEffect(() => {
    if (recoverySelectedGroupCamera) {
      const { keys, row } = recoverySelectedGroupCamera;
      onSelectGroupCamera(keys, row, true);
    }
  }, [recoverySelectedGroupCamera]);

  useEffect(() => {
    if (
      recoverySelectedMember &&
      JSON.stringify(recoverySelectedMember) !== JSON.stringify(selectedRowKeys)
    ) {
      setSelectedRowKeys(recoverySelectedMember);
      handleListDeviceByUser(recoverySelectedMember[0]);
    }
  }, [recoverySelectedMember, selectedRowKeys, handleListDeviceByUser]);

  return (
    <div className="organization-component">
      {isAdmin && (
        <div className="button-tab">
          <div className="button-tab-left">
            <Button
              type={activeTab === 0 ? 'primary' : 'default'}
              style={{ marginLeft: 'auto', width: '96px' }}
              onClick={() => {
                setActiveTab(0);
                dispatch(updateRecoverySharePage({ activeTab: 0 }));
                onResetUserShare();
                setKeyTable(Math.random());
                setEditGroupPermissionData(null);
              }}
            >
              {t('Camera')}
            </Button>
            <Button
              type={activeTab === 2 ? 'primary' : 'default'}
              style={{ marginLeft: '8px' }}
              onClick={() => {
                setActiveTab(2);
                dispatch(updateRecoverySharePage({ activeTab: 2 }));
                onResetUserShare();
                setKeyTable(Math.random());
                setEditGroupPermissionData(null);
              }}
            >
              {t('Group camera')}
            </Button>
            <Button
              type={activeTab === 1 ? 'primary' : 'default'}
              style={{ marginLeft: '8px', width: '96px' }}
              onClick={() => {
                setActiveTab(1);
                dispatch(updateRecoverySharePage({ activeTab: 1 }));
                onResetUserShare();
                setKeyTable(Math.random());
                setEditGroupPermissionData(null);
              }}
            >
              {t('Member')}
            </Button>
          </div>
          <div>
            <Button
              type={'primary'}
              style={{ marginLeft: '8px' }}
              icon={<DownloadOutlined />}
              loading={isLoadingExport}
              onClick={handleExportAccountReports}
            >
              {t('Export')}
            </Button>
          </div>
        </div>
      )}
      {activeTab === 0 && (
        <div
          className="organization-component-camera"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <LazyloadingSelect
                size={10}
                value={currentCameragroup}
                onChange={onChangeSelect}
                serviceId={SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2}
                searchField="name"
                reduxVariableName="listDeviceGroupByPage"
                defaultOption={{ value: 0, label: t('All camera') }}
                convertOptionData={(listDeviceGroupByPage) =>
                  listDeviceGroupByPage.deviceGroups?.map((item) => ({
                    ...item,
                    value: item.id,
                    label: item.name,
                  }))
                }
                selectProps={{
                  style: { width: '100%' },
                }}
              />
            </div>
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <Search
                placeholder={t('Search camera')}
                onSearch={onSearchCamera}
                allowClear
                value={dataSearchCamera}
                onChange={(e) => {
                  setDataSearchCamera(e.target.value);
                  dispatch(
                    updateRecoveryCameraTabOfSharePage({
                      searchCamera: e.target.value,
                    }),
                  );
                }}
              />
            </div>
            <div className="select-section">
              <Table
                key={keyTable}
                size="middle"
                scroll={{ y: 'calc(100vh - 327px)' }}
                dataSource={
                  cameras &&
                  cameras.data &&
                  cameras &&
                  cameras.data.map((camera) => ({
                    ...camera,
                    key: camera.serial,
                  }))
                }
                pagination={cameras && cameras.pagination}
                loading={cameras && cameras.loading}
                onChange={handleTableChange}
                rowSelection={{
                  getCheckboxProps: (record) => {
                    console.log('🚀 ~ OrganizationPage ~ record:', record);
                    return {
                      disabled: !record?.permission?.includes('share'),
                      key: record.serial,
                    };
                  },
                  preserveSelectedRowKeys: true,
                  selectedRowKeys: selectedRowKeysCameraTab,
                  onChange: (keys, row) => onRowSelectionCameraTab(keys, row),
                }}
                columns={[
                  {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name_of_camera_',
                    render: (cell, row) => {
                      return (
                        <div>
                          <div>{cell}</div>
                          <div
                            style={{
                              fontSize: '12px',
                              color: colorsDark.$online,
                              textDecoration: 'underline',
                            }}
                          >
                            {row?.permission?.replaceAll('_', ', ')}
                          </div>
                        </div>
                      );
                    },
                  },

                  {
                    title: t('State'),
                    key: 'state_of_camera',
                    dataIndex: 'state',
                    width: '85px',
                    render: (value) => <StateTag state={value} />,
                  },
                ]}
              />
            </div>
          </div>
          <div className="table-organization-component">
            <Table
              pagination={false}
              footer={() => (
                <div className="select-share-user">
                  <style>
                    {`.table-organization-component .ant-table-footer {
                margin-top: -10px;
              }`}
                  </style>
                  {stepAdd === 0 ? (
                    <div className="share-user-button">
                      <div className="btn">
                        <Button
                          type="primary"
                          disabled={!checkCam}
                          onClick={() => setStepAdd(1)}
                          icon={<ShareAltOutlined />}
                        >
                          {t('Share access permission')}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Form
                      form={form}
                      name="add-user-permission"
                      layout="inline"
                      onFinish={(values) => onShareUser(values)}
                      initialValues={{
                        select: checkSelect,
                        groupId: `${filterGroupId}`,
                        accountId: `${filterAccountId}`,
                      }}
                    >
                      <Row style={{ width: '100%' }}>
                        <Col span={4}>
                          <Form.Item
                            name="select"
                            rules={[
                              {
                                required: true,
                                message: t('Please enter type'),
                              },
                            ]}
                          >
                            <Select
                              style={{ marginRight: '0px' }}
                              placeholder={t('Select type')}
                              onChange={(value) => {
                                setFilterAccountId(null);
                                setFilterGroupId(null);
                                setFilterSerial(null);
                                setCheckFilterShare(null);
                                setCheckSelect(value);
                                handleFilerType(value);
                                form.setFieldsValue({
                                  groupId: null,
                                  accountId: null,
                                });
                              }}
                            >
                              <Select.Option key={1}>
                                {t('Group members')}
                              </Select.Option>
                              <Select.Option key={2}>
                                {t('Member')}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {checkSelect ? (
                          <Col span={6}>
                            {checkSelect === '1' ? (
                              <Form.Item
                                name="groupId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter group members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  style={{ marginRight: '0px' }}
                                  placeholder={t('Select group members')}
                                  onChange={(value) => {
                                    setFilterGroupId(Number(value));
                                    setFilterAccountId(null);
                                    handleFilerGroup(value);
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                >
                                  {groupMembers.map((d) => (
                                    <Select.Option key={d.id}>
                                      {d.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : (
                              <Form.Item
                                name="accountId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder={t('Select members')}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    const data =
                                      (option &&
                                        option.children &&
                                        option.children.props &&
                                        option.children.props.children &&
                                        option.children.props.children[0] &&
                                        option.children.props.children[0]
                                          .props &&
                                        option.children.props.children[0].props
                                          .children) ||
                                      '';
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  onChange={(value) => {
                                    setFilterAccountId(Number(value));
                                    setFilterGroupId(null);
                                    handleFilerMember(value);
                                  }}
                                >
                                  {accountByNamespace.map((d) => (
                                    <Select.Option key={d.accountId}>
                                      {/* <Row gutter={8}>
                                  <Col span={8}>{d.phonenumber}</Col>
                                  <Col span={10}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.fullName}</div></Col>
                                  <Col span={6}>
                                    <Tag color={memberRoleColors(d.role)}>
                                      {d.role && d.role.toUpperCase()}
                                    </Tag>
                                  </Col>
                                </Row> */}
                                      {d.fullName
                                        ? `${d.phonenumber} (${d.fullName})`
                                        : d.phonenumber}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            )}
                          </Col>
                        ) : (
                          <Col span={6}></Col>
                        )}
                        {checkSelect && (
                          <Col span={5}>
                            <Select
                              mode="multiple"
                              style={{ paddingRight: '16px', width: '100%' }}
                              placeholder={t('Select permission')}
                              onChange={(value) => {
                                setDataPermissionSubmit(value ?? []);
                              }}
                            >
                              {dataPermission.map((item) => (
                                <Select.Option
                                  key={item}
                                  style={{ textTransform: 'capitalize' }}
                                >
                                  {t(item[0].toUpperCase() + item.substring(1))}
                                </Select.Option>
                              ))}
                            </Select>
                          </Col>
                        )}
                        {checkSelect && (
                          <Col span={3}>
                            <InputNumber
                              style={{ width: '100%' }}
                              min={0}
                              placeholder="Please enter day"
                              value={duration}
                              formatter={(value) => `${value || ''} Day`}
                              parser={
                                (value) =>
                                  value
                                    .replace(/Da|D|Dy|a|ay|y|Day/g, '')
                                    .trim()
                                // Xử lý khi bấm backspace
                              }
                              onChange={(value) => {
                                setDuration(value);
                              }}
                            />
                          </Col>
                        )}
                        <Col span={checkSelect ? 6 : 14}>
                          <div
                            className="button-side"
                            style={{ justifyContent: 'flex-end' }}
                          >
                            <Form.Item shouldUpdate={true}>
                              {() => (
                                <Button
                                  icon={<ShareAltOutlined />}
                                  htmlType="submit"
                                  type="primary"
                                  className="btn-add-share-person"
                                  loading={isAddUserLoading || isShareLoading}
                                  disabled={
                                    !checkCam ||
                                    !checkFilterShare ||
                                    !userShares ||
                                    !userShares.serials ||
                                    !dataPermissionSubmit?.length ||
                                    duration === null ||
                                    form
                                      .getFieldsError()
                                      .filter(({ errors }) => errors.length)
                                      .length
                                  }
                                >
                                  {t('Share')}
                                </Button>
                              )}
                            </Form.Item>
                            <Form.Item>
                              <Button
                                onClick={() => {
                                  form.resetFields();
                                  setIsAddUserLoading(false);
                                  setStepAdd(0);
                                  setCheckSelect(null);
                                  setFilterAccountId(null);
                                  setFilterGroupId(null);
                                  setFilterSerial(null);
                                  setCheckFilterShare(null);
                                  setUserShares({ ...userShareDevice });
                                  setDataPermissionSubmit([]);
                                  form.setFieldsValue({
                                    select: null,
                                  });
                                }}
                              >
                                {t('Cancel')}
                              </Button>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </div>
              )}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'fullName',
                  key: 'fullName-share-device',
                  width: '15%',
                  render: (cell, row) => {
                    return row.groupId === -1 ? cell : row.groupName;
                  },
                },
                {
                  title: t('Camera'),
                  dataIndex: 'serial',
                  key: 'serial-share-device',
                  width: '15%',
                  render: (cell) => {
                    const data =
                      cameras &&
                      cameras.data &&
                      cameras.data.length > 0 &&
                      cameras.data.find((item) => item.serial === cell);
                    return (data && data.name) || '';
                  },
                },
                {
                  title: t('Type'),
                  key: 'type-share-device',
                  dataIndex: 'groupId',
                  width: '15%',
                  render: (value) =>
                    value === -1 ? (
                      <Tag color={colorsDark.$offline}>{t('Member')}</Tag>
                    ) : (
                      <Tag color={colorsDark.$online}>{t('Group Member')}</Tag>
                    ),
                },
                {
                  title: t('Permission'),
                  key: 'permission-share-device',
                  dataIndex: 'permission',
                  render: (value, row) => {
                    const permissionData = value
                      .split('_')
                      .reduce((acc, item) => {
                        if (item) {
                          acc[item] = true;
                        }
                        return acc;
                      }, {});
                    const permissions = [
                      'download',
                      'live',
                      'playback',
                      'upload',
                      'share',
                    ];

                    const enabled =
                      row.groupId === editGroupPermissionData?.groupId &&
                      row.serial === editGroupPermissionData?.serial;

                    return (
                      <div
                        style={{
                          display: 'flex',
                          gap: '4px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {permissions.map((permission) => (
                          <Checkbox
                            key={permission}
                            checked={
                              enabled
                                ? editGroupPermissionData?.permissionData[
                                    permission
                                  ]
                                : permissionData[permission]
                            }
                            disabled={!enabled}
                            onChange={(e) =>
                              updateGroupPermission(
                                permission,
                                e.target.checked,
                              )
                            }
                            className="permission-checkbox"
                          >
                            {permission}
                          </Checkbox>
                        ))}
                      </div>
                    );
                  },
                },
                {
                  title: t('Action'),
                  key: 'action-share-device',
                  width: '20%',
                  render: (user, row, index) => {
                    const isActiveEdit =
                      row.groupId === editGroupPermissionData?.groupId &&
                      row.serial === editGroupPermissionData?.serial;

                    const activeEditContent = () => {
                      return (
                        <>
                          <div
                            className="edit-button"
                            onClick={() => commitEditGroupPermission()}
                          >
                            {t('Save')}
                          </div>
                          <div
                            className="edit-button"
                            onClick={() => {
                              setEditGroupPermissionData(null);
                            }}
                          >
                            {t('Cancel')}
                          </div>
                        </>
                      );
                    };

                    const inactiveEditContent = () => {
                      return (
                        <>
                          {row.groupId !== -1 && (
                            <div
                              className="edit-button"
                              onClick={() =>
                                activeEditGroupPermission({
                                  serial: row.serial,
                                  deviceGroupId: row.deviceGroupId ?? -1,
                                  groupId: row.groupId,
                                  permission: row.permission,
                                })
                              }
                            >
                              <EditOutlined /> {t('Edit')}
                            </div>
                          )}
                          <div
                            className="edit-button"
                            onClick={() => {
                              beeXLogger.debug(
                                'handleRemoveShareUser -: ',
                                row,
                              );
                              handleRemoveShareUser(
                                row.groupId,
                                row.accountId,
                                row.serial,
                              );
                            }}
                          >
                            <DeleteOutlined /> {t('Remove')}
                          </div>
                        </>
                      );
                    };

                    return (
                      <div className="remove-users-button">
                        <div className="manager-member-actions">
                          {isActiveEdit
                            ? activeEditContent()
                            : inactiveEditContent()}
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              dataSource={
                checkCam &&
                userShares &&
                userShares.users &&
                userShares.users.length > 0 &&
                userShares.users
                  .filter((item) => {
                    if (
                      !unShareUserRef.current ||
                      unShareUserRef.current.length === 0
                    ) {
                      return true;
                    }

                    return !unShareUserRef.current.some(
                      (us) =>
                        us?.data?.accountId === item?.accountId &&
                        us?.data?.groupId === item?.groupId &&
                        us?.data?.serial === item?.serial,
                    );
                  })
                  .map((user, index) => ({
                    ...user,
                    key: index,
                  }))
              }
              scroll={{ y: '70vh' }}
              expandable={{ expandedRowRender }}
            />
          </div>
        </div>
      )}
      {activeTab === 1 && (
        <div
          className="organization-component-camera tab-member"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <Input
                placeholder="Search user"
                onChange={handleSearchAccount}
                value={searchMemberInput}
              />
            </div>
            <div className="select-section">
              <Table
                key={keyTable}
                size="middle"
                scroll={{ y: 'calc(100vh - 286px)' }}
                dataSource={accountResult?.map((account) => ({
                  ...account,
                  key: account.accountId,
                }))}
                rowSelection={{
                  type: 'radio',
                  selectedRowKeys,
                  getCheckboxProps: (record) => {
                    return {
                      key: record.accountId,
                    };
                  },
                  preserveSelectedRowKeys: true,
                  onChange: (keys, row) => {
                    setSelectedRowKeys(keys);
                    dispatch(
                      updateRecoveryMemberTabOfSharePage({
                        selectedMember: keys,
                      }),
                    );
                    beeXLogger.debug(
                      '🚀 ~ OrganizationPage ~ activeMemberTab:',
                      activeMemberTab,
                    );
                    if (activeMemberTab === '1') {
                      handleListDeviceByUser(keys[0]);
                    } else if (activeMemberTab === '2') {
                      beeXLogger.debug(
                        'onChange - Group camera - keys: ',
                        keys,
                      );
                      handleListDeviceGroupByUser(keys[0]);
                    }
                  },
                }}
                columns={[
                  {
                    title: t('FullName'),
                    dataIndex: 'fullName',
                    key: 'fullName',
                    render: (cell, row) => {
                      return <div>{cell ? cell : '_'}</div>;
                    },
                  },
                  {
                    title: t('Phone Number'),
                    key: 'phonenumber',
                    dataIndex: 'phonenumber',
                    width: '120px',
                    render: (value) => value,
                  },
                ]}
                pagination={{
                  current: recoveryPaginationMember?.page || undefined,
                  pageSize: recoveryPaginationMember?.pageSize || undefined,

                  onChange: (page, pageSize) => {
                    dispatch(
                      updateRecoveryMemberTabOfSharePage({
                        pagination: {
                          page,
                          pageSize,
                        },
                      }),
                    );
                  },
                }}
              />
            </div>
          </div>
          <div className="table-organization-component">
            {/* New feature */}
            <Tabs
              defaultActiveKey={activeMemberTab || '1'}
              onChange={(key) => onChangeMemberTab(key)}
            >
              <TabPane tab={t('Camera')} key="1">
                {activeMemberTab === '1' && (
                  <Table
                    key={keyTable}
                    size="middle"
                    scroll={{ y: 'calc(100vh - 286px)' }}
                    dataSource={camerasByUser?.data?.map((camera) => ({
                      ...camera,
                      key: `${camera.serial}-${
                        camera.deviceGroup?.deviceGroupId || -1
                      }-${camera.group?.groupId || -1}`,
                    }))}
                    pagination={camerasByUser?.pagination}
                    loading={camerasByUser?.loading}
                    onChange={handleTableChangeMember}
                    columns={[
                      {
                        title: t('Name'),
                        dataIndex: 'name',
                        key: 'name_of_camera_',
                        render: (cell) => <div>{cell}</div>,
                      },
                      {
                        title: t('Permission'),
                        dataIndex: 'permission',
                        key: 'permission_of_camera',
                        render: (value) =>
                          value
                            ? value.split('_').map((perm) => (
                                <Tag
                                  key={perm}
                                  color={colorsDark.$online}
                                  style={{ marginBottom: 4 }}
                                >
                                  {perm}
                                </Tag>
                              ))
                            : '-',
                      },
                      {
                        title: t('State'),
                        key: 'state_of_camera',
                        dataIndex: 'state',
                        width: '85px',
                        render: (value) => <StateTag state={value} />,
                      },
                      {
                        title: t('Device Group'),
                        key: 'group-share-device',
                        dataIndex: 'deviceGroup',
                        render: (value) => value?.name ?? '-',
                      },
                      {
                        title: t('Group'),
                        key: 'group-share-group',
                        dataIndex: 'group',
                        render: (value) => value?.name ?? '-',
                      },
                      {
                        title: t('Action'),
                        key: 'actions ',
                        width: '60px',
                        align: 'center',
                        render: (record) => (
                          <Tooltip title={t('Remove permission')}>
                            <span
                              className="edit-button"
                              onClick={() => onRemovePermission(record)}
                              style={{ cursor: 'pointer' }}
                            >
                              <DeleteOutlined />
                            </span>
                          </Tooltip>
                        ),
                      },
                    ]}
                  />
                )}
              </TabPane>
              <TabPane tab={t('Group camera')} key="2">
                {activeMemberTab === '2' && (
                  <Table
                    key={keyTable}
                    size="middle"
                    scroll={{ y: 'calc(100vh - 286px)' }}
                    dataSource={cameraGroupsByUser?.data?.map((group) => ({
                      ...group,
                      key: group.deviceGroupId,
                    }))}
                    pagination={cameraGroupsByUser?.pagination}
                    loading={cameraGroupsByUser?.loading}
                    onChange={handleTableGroupCameraChangeOfMember}
                    columns={[
                      {
                        title: t('Name'),
                        dataIndex: 'name',
                        key: 'name',
                        render: (cell) => <div>{cell}</div>,
                      },
                      {
                        title: t('Permission'),
                        dataIndex: 'permission',
                        key: 'permission_of_camera_group',
                        render: (value) =>
                          value
                            ? value.split('_').map((perm) => (
                                <Tag
                                  key={perm}
                                  color={colorsDark.$online}
                                  style={{ marginBottom: 4 }}
                                >
                                  {perm}
                                </Tag>
                              ))
                            : '-',
                      },
                      {
                        title: t('Created at'),
                        dataIndex: 'createdAt',
                        key: 'created_at_of_camera_group',
                        render: (cell) =>
                          moment(cell).format('DD/MM/YYYY HH:mm:ss'),
                      },
                      {
                        title: t('Action'),
                        key: 'actions ',
                        width: '60px',
                        align: 'center',
                        render: (record) => (
                          <Tooltip title={t('Remove permission')}>
                            <span
                              className="edit-button"
                              onClick={() => onRemovePermission(record)}
                              style={{ cursor: 'pointer' }}
                            >
                              <DeleteOutlined />
                            </span>
                          </Tooltip>
                        ),
                      },
                    ]}
                  />
                )}
              </TabPane>
            </Tabs>
          </div>
        </div>
      )}
      {activeTab === 2 && (
        <div
          className="organization-component-camera"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <GroupTree
              namespace={namespace}
              onSelect={(keys, row) => onSelectGroupCamera(keys, row)}
              onSearch={(value) => {
                dispatch(
                  updateRecoveryGroupCameraTabOfSharePage({
                    searchGroupCamera: value,
                  }),
                );
              }}
            />
          </div>
          <div className="table-organization-component">
            <Table
              pagination={false}
              footer={() => (
                <div className="select-share-user">
                  <style>
                    {`.table-organization-component .ant-table-footer {
                margin-top: -10px;
              }`}
                  </style>
                  {stepAdd === 0 ? (
                    <div className="share-user-button">
                      <div className="btn">
                        <Button
                          type="primary"
                          disabled={!checkCam}
                          onClick={() => setStepAdd(1)}
                          icon={<ShareAltOutlined />}
                        >
                          {t('Share access permission')}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Form
                      form={form}
                      name="add-user-permission"
                      layout="inline"
                      onFinish={(values) =>
                        onShareUser({
                          ...values,
                          deviceGroupId: dataGroupIdSelect,
                        })
                      }
                      initialValues={{
                        select: checkSelect,
                        groupId: `${filterGroupId}`,
                        accountId: `${filterAccountId}`,
                      }}
                    >
                      <Row style={{ width: '100%' }}>
                        <Col span={4}>
                          <Form.Item
                            name="select"
                            rules={[
                              {
                                required: true,
                                message: t('Please enter type'),
                              },
                            ]}
                          >
                            <Select
                              style={{ marginRight: '0px' }}
                              placeholder={t('Select type')}
                              onChange={(value) => {
                                setFilterAccountId(null);
                                setFilterGroupId(null);
                                setFilterSerial(null);
                                setCheckFilterShare(null);
                                setCheckSelect(value);
                                handleFilerType(value);
                                form.setFieldsValue({
                                  groupId: null,
                                  accountId: null,
                                });
                              }}
                            >
                              <Select.Option key={1}>
                                {t('Group members')}
                              </Select.Option>
                              <Select.Option key={2}>
                                {t('Member')}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {checkSelect ? (
                          <Col span={6}>
                            {checkSelect === '1' ? (
                              <Form.Item
                                name="groupId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter group members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  style={{ marginRight: '0px' }}
                                  placeholder={t('Select group members')}
                                  onChange={(value) => {
                                    setFilterGroupId(Number(value));
                                    setFilterAccountId(null);
                                    handleFilerGroupDeviceSelect(value);
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                >
                                  {groupMembers.map((d) => (
                                    <Select.Option key={d.id}>
                                      {d.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : (
                              <Form.Item
                                name="accountId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder={t('Select members')}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    const data =
                                      (option &&
                                        option.children &&
                                        option.children.props &&
                                        option.children.props.children &&
                                        option.children.props.children[0] &&
                                        option.children.props.children[0]
                                          .props &&
                                        option.children.props.children[0].props
                                          .children) ||
                                      '';
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  onChange={(value) => {
                                    setFilterAccountId(Number(value));
                                    setFilterGroupId(null);
                                    handleFilerMember(value);
                                  }}
                                >
                                  {accountByNamespace.map((d) => (
                                    <Select.Option key={d.accountId}>
                                      {d.fullName
                                        ? `${d.phonenumber} (${d.fullName})`
                                        : d.phonenumber}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            )}
                          </Col>
                        ) : (
                          <Col span={6}></Col>
                        )}
                        {checkSelect && (
                          <Col span={5}>
                            <Select
                              mode="multiple"
                              style={{ paddingRight: '16px', width: '100%' }}
                              placeholder={t('Select permission')}
                              onChange={(value) => {
                                setDataPermissionSubmit(value ?? []);
                              }}
                            >
                              {[
                                'live',
                                'playback',
                                'download',
                                'upload',
                                'share',
                              ].map((item) => (
                                <Select.Option
                                  key={item}
                                  style={{ textTransform: 'capitalize' }}
                                >
                                  {t(item[0].toUpperCase() + item.substring(1))}
                                </Select.Option>
                              ))}
                            </Select>
                          </Col>
                        )}
                        {checkSelect && (
                          <Col span={3}>
                            <InputNumber
                              style={{ width: '100%' }}
                              min={0}
                              placeholder="Please enter day"
                              value={duration}
                              formatter={(value) => `${value || ''} Day`}
                              parser={
                                (value) =>
                                  value
                                    .replace(/Da|D|Dy|a|ay|y|Day/g, '')
                                    .trim()
                                // Xử lý khi bấm backspace
                              }
                              onChange={(value) => {
                                setDuration(value);
                              }}
                            />
                          </Col>
                        )}
                        <Col span={checkSelect ? 6 : 14}>
                          <div
                            className="button-side"
                            style={{
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Form.Item shouldUpdate={true}>
                              {() => (
                                <Button
                                  icon={<ShareAltOutlined />}
                                  htmlType="submit"
                                  type="primary"
                                  className="btn-add-share-person"
                                  loading={isAddUserLoading || isShareLoading}
                                  disabled={
                                    !checkCam ||
                                    !userShareGroupDevice.deviceGroupId ||
                                    !dataPermissionSubmit?.length ||
                                    duration === null ||
                                    form
                                      .getFieldsError()
                                      .filter(({ errors }) => errors.length)
                                      .length
                                  }
                                >
                                  {t('Share')}
                                </Button>
                              )}
                            </Form.Item>
                            <Form.Item>
                              <Button
                                onClick={() => {
                                  form.resetFields();
                                  setIsAddUserLoading(false);
                                  setStepAdd(0);
                                  setCheckSelect(null);
                                  setFilterAccountId(null);
                                  setFilterGroupId(null);
                                  setFilterSerial(null);
                                  setCheckFilterShare(null);
                                  setUserShares({ ...userShareDevice });
                                  setDataPermissionSubmit([]);
                                  form.setFieldsValue({
                                    select: null,
                                  });
                                }}
                              >
                                {t('Cancel')}
                              </Button>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </div>
              )}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'fullName',
                  key: 'fullName-share-device-group',
                  render: (cell, row) => {
                    return row.groupId ? row.groupName : cell;
                  },
                },
                {
                  title: t('Type'),
                  key: 'type-share-device',
                  dataIndex: 'groupId',
                  render: (value) =>
                    !!value && value !== -1 ? (
                      <Tag color={colorsDark.$online}>{t('Group Member')}</Tag>
                    ) : (
                      <Tag color={colorsDark.$offline}>{t('Member')}</Tag>
                    ),
                },
                {
                  title: t('Permission'),
                  key: 'permission-share-device',
                  dataIndex: 'permission',
                  width: '32%',
                  render: (cell, row, index) => {
                    const dataArr = (cell && cell.split('_')) || [];
                    let check1 = false;
                    let check2 = false;
                    let check3 = false;
                    let check4 = false;
                    let check5 = false;
                    if (dataArr.find((item) => item === 'live')) {
                      check1 = true;
                    }
                    if (dataArr.find((item) => item === 'playback')) {
                      check2 = true;
                    }
                    if (dataArr.find((item) => item === 'download')) {
                      check3 = true;
                    }
                    if (dataArr.find((item) => item === 'upload')) {
                      check4 = true;
                    }
                    if (dataArr.find((item) => item === 'share')) {
                      check5 = true;
                    }
                    const onChange = (e, key) => {
                      if (key === 'live') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (!check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'playback') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (!check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'download') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (!check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'upload') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (!check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'share') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (!check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      }
                    };
                    return (
                      <React.Fragment>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'live')}
                          checked={check1}
                        >
                          {t('Live')}
                        </Checkbox>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'playback')}
                          checked={check2}
                        >
                          {t('Playback')}
                        </Checkbox>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'download')}
                          checked={check3}
                        >
                          {t('Download')}
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '0px' }}
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'upload')}
                          checked={check4}
                        >
                          {t('Upload')}
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '0px' }}
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'share')}
                          checked={check5}
                        >
                          {t('Share')}
                        </Checkbox>
                        {/* </Radio.Group> */}
                      </React.Fragment>
                    );
                  },
                },
                {
                  title: t('Action'),
                  key: 'action-share-device',
                  width: '25%',
                  render: (user, row, index) => {
                    return (
                      <div className="remove-users-button">
                        <div>
                          {checkEdit === index && checkGroupId === row.id ? (
                            <>
                              <Button
                                loading={
                                  isDeleteLoading ===
                                  userShareGroupDevice?.deviceGroupId
                                }
                                style={{ marginRight: '10px' }}
                                size="small"
                                type="primary"
                                onClick={() =>
                                  handleUpdateShare(
                                    row.groupId ?? -1,
                                    row.accountId ?? -1,
                                    row.permission,
                                    '',
                                    userShareGroupDevice?.deviceGroupId,
                                  )
                                }
                              >
                                {t('Update')}
                              </Button>
                              <Button
                                loading={
                                  isDeleteLoading ===
                                  userShareGroupDevice?.deviceGroupId
                                }
                                size="small"
                                onClick={() => handleCancelShare()}
                              >
                                {t('Cancel')}
                              </Button>
                            </>
                          ) : (
                            <div className="manager-member-actions">
                              <div
                                className="edit-button"
                                onClick={() => {
                                  setCheckEdit(index);
                                  setCheckUpdate(index);
                                  setCheckGroupId(row.id);
                                  handleFilerGroupDevice();
                                }}
                              >
                                <EditOutlined /> {t('Edit')}
                              </div>
                              <div
                                className="edit-button"
                                onClick={() => {
                                  beeXLogger.debug('row', row);
                                  handleRemoveShareUser(
                                    row?.groupId,
                                    row?.accountId,
                                    row?.serials,
                                    userShareGroupDevice?.deviceGroupId,
                                  );
                                }}
                              >
                                <DeleteOutlined /> {t('Remove')}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              dataSource={
                checkCam &&
                userShareGroupDevice?.groups.map((groupItem, index) => ({
                  ...groupItem,
                  key: index,
                }))
              }
              scroll={{ y: '70vh' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationPage;
